import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "@/components/AppShell";
import api from "@/lib/api";
import { CheckCircle2, XCircle, ArrowRight } from "lucide-react";

export default function Results() {
  const [attempts, setAttempts] = useState([]);
  useEffect(() => {
    api.get("/attempts/mine").then((r) => setAttempts(r.data));
  }, []);
  return (
    <AppShell title="My results" subtitle="Every exam you've taken so far.">
      <div className="qs-card overflow-hidden" data-testid="results-table">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-widest">
              <tr>
                <th className="text-left px-4 py-3 font-bold">Exam</th>
                <th className="text-left px-4 py-3 font-bold">Score</th>
                <th className="text-left px-4 py-3 font-bold">Result</th>
                <th className="text-left px-4 py-3 font-bold">Submitted</th>
                <th className="text-right px-4 py-3 font-bold">Details</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {attempts.map((a) => (
                <tr key={a.id} className="hover:bg-slate-50 transition" data-testid={`result-row-${a.id}`}>
                  <td className="px-4 py-3 font-semibold text-slate-800">{a.exam_title}</td>
                  <td className="px-4 py-3 text-slate-700">{a.score_percent}% ({a.score}/{a.total_points})</td>
                  <td className="px-4 py-3">
                    {a.status === "submitted" ? (
                      a.passed ? (
                        <span className="inline-flex items-center gap-1 text-emerald-700"><CheckCircle2 className="w-4 h-4" /> Passed</span>
                      ) : (
                        <span className="inline-flex items-center gap-1 text-rose-600"><XCircle className="w-4 h-4" /> Failed</span>
                      )
                    ) : (
                      <span className="text-slate-500">In progress</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-slate-500">{a.submitted_at ? new Date(a.submitted_at).toLocaleString() : "—"}</td>
                  <td className="px-4 py-3 text-right">
                    <Link to={`/dashboard/attempts/${a.id}`} className="text-indigo-600 font-semibold text-sm inline-flex items-center gap-1" data-testid={`view-attempt-${a.id}`}>
                      View <ArrowRight className="w-4 h-4" />
                    </Link>
                  </td>
                </tr>
              ))}
              {attempts.length === 0 && (
                <tr>
                  <td colSpan={5} className="px-4 py-12 text-center text-slate-500" data-testid="no-results">
                    No attempts yet. Take an exam to see results here.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </AppShell>
  );
}
